import { NativeDateAdapter } from '@angular/material/core';
import { Injectable } from '@angular/core';
@Injectable()
export class SwedishDateAdapter extends NativeDateAdapter {
  constructor() {
    super('sv');
  }
  getFirstDayOfWeek(): number {
    return 1;
  }
}